import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50456602"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-title" }
const _hoisted_2 = { class: "modal-content security-modal" }
const _hoisted_3 = { class: "review-guide" }
const _hoisted_4 = { class: "review-list" }
const _hoisted_5 = { class: "review-table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "이름"),
    /*#__PURE__*/_createElementVNode("th", null, "아이디"),
    /*#__PURE__*/_createElementVNode("th", null, "마지막 로그인"),
    /*#__PURE__*/_createElementVNode("th", null, "켜진 메뉴")
  ])
], -1))
const _hoisted_7 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    open: !!_ctx.state.rows,
    footer: null,
    "mask-closable": false,
    width: 720,
    onCancel: _ctx.review.later
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.TEXT.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.TEXT.guide), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.rows || [], (r) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: r.accountId
                }, [
                  _createElementVNode("td", null, _toDisplayString(r.name), 1),
                  _createElementVNode("td", null, _toDisplayString(r.username), 1),
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(r.lastLogin) + " ", 1),
                    (r.inactive90)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "orange"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.TEXT.inactive), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(r.menus), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_button, {
            disabled: _ctx.state.busy,
            onClick: _ctx.review.later
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.TEXT.later), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            loading: _ctx.state.busy,
            onClick: _ctx.review.confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.TEXT.confirm), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open", "onCancel"]))
}